import styled from 'styled-components';

export const Pest = styled.div`
  background: white;
  min-height: 100%;
`
